<template>
  <v-card class="import-a-sor">
    <v-card-title class="justify-center">
      {{ $t('a_sor.import_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('a_sor.excel') }}
          </v-col>
          <v-col cols="9">
            <FileInput v-model="excelFile"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       :rules="requiredRules"></FileInput>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('a_sor.special_conditions_pdf') }}
          </v-col>
          <v-col cols="9">
            <FileInput v-model="specialConditionsFile"
                       accept="application/pdf"></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && confirm()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import FileInput from "@/components/FileInput";

export default {
  name: 'ImportContractASoRDialog',
  components: {FileInput},
  props: {
    aSorId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required'),
    ]);

    const name = ref('');
    const excelFile = ref(null);
    const specialConditionsFile = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append('a_sor_id', props.aSorId);
      formData.append('excel', excelFile.value, excelFile.value.name);
      if (specialConditionsFile.value) {
        formData.append('special_conditions', specialConditionsFile.value, specialConditionsFile.value.name);
      }

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/a_sor/import/',
        params: formData,
      });

      if (response.body.success) {
        emit('submit', true)
      }
    }

    return {
      requiredRules,

      name,
      excelFile,
      specialConditionsFile,

      confirm,
    }
  },
}
</script>

<style lang="less">
.import-a-sor {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
